import { RuleTableHandlers, TableConfig } from '../../../../../shared/ui/custom-table/model/table-config.model';
import { Location } from '../../models/location.model';

export enum TableRowAction {
  Configure = 'configure',
  Edit = 'edit',
  Access = 'access',
  Delete = 'delete',
  AdminPanel = 'admin_panel'
}

export function createLocationTableConfig(
  handlers: RuleTableHandlers = {},
  options: { filterView?: string } = {}
): TableConfig {
  const {
    onCreate = () => { },
    onEdit = () => { },
    onDelete = () => { },
    onAction = () => { },
    actionMap = {},
    onRowClick = () => { },
    onRowDblClick = () => { },
    onRowExpand = () => { },
    columns = [],
  } = handlers;

  const handleAction = (row: any, action: TableRowAction) => {
    if (actionMap[action]) {
      actionMap[action](row);
    } else {
      onAction(row, action);
    }
  };

  return {
    columns: columns,
    actions: [
      { label: 'Acceder', icon: 'open_in_new', callback: (row) => handleAction(row, TableRowAction.Access) },
      { label: 'Panel de administración', icon: 'admin_panel_settings', callback: (row) => handleAction(row, TableRowAction.AdminPanel) },
      { label: 'Eliminar', icon: 'delete', callback: (row) => handleAction(row, TableRowAction.Delete) }
    ],
    headerActions: [
      { label: '', icon: 'add', type: 'button', callback: onCreate }
    ],
    filterView: options.filterView || 'locations',
    rowConfig: {
      clickable: true,
      onClick: onRowClick,
      onDoubleClick: onRowDblClick,
      onExpand: onRowExpand
    },
    selectable: false,
    pagination: false
  };
}
